import angular from 'angular';

import ThingsServiceProvider from './../services/things.service';
import MapServiceProvider from './../services/map.service';
import HomeComponent from './home-view';
import OverviewComponent from './overview-list';
import CartTableComponent from './cart-table';

const module = angular
    .module('app.home', [])
    .service(ThingsServiceProvider.name, ThingsServiceProvider)
    .service(MapServiceProvider.name, MapServiceProvider)
    .component(HomeComponent.selector, HomeComponent)
    .component(OverviewComponent.selector, OverviewComponent)
    .component(CartTableComponent.selector, CartTableComponent)
    ;

export default module.name;



// WEBPACK FOOTER //
// ./src/app/home/index.js